// extracted by mini-css-extract-plugin
export default {"footer_main":"Footer_footer_main__z4mP-","soc_links":"Footer_soc_links__D5twz"};